import type {
  TariffRequestResponse,
  TariffSearchRequestBody,
} from '@/features/Tariffs/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class TariffsHttpService extends HttpService {
  requestTariffs(
    requestBody: TariffSearchRequestBody,
  ): HttpClientResponse<TariffRequestResponse> {
    return this.httpClient.post('tarif', {
      data: requestBody,
    });
  }

  requestTariffsByCalculationId(
    berechnungsId: string,
  ): HttpClientResponse<TariffRequestResponse> {
    return this.httpClient.get(`tarif/${berechnungsId}`);
  }
}
